export default __webpack_public_path__ + "static/slider.wko.klein-3d9aca7d4e096d6c2185c08ce409b3a3.webp";